import { useId, useState } from 'react';
import type { VideoJob } from '../services/local-video';

export function VideoCatalogActions({ job, edit }: { job: VideoJob; edit(id: string, title?: string): Promise<void> }) {
  const [title, setTitle] = useState(job.title);
  const [busy, setBusy] = useState(false);
  const titleId = useId();
  const apply = async (name?: string) => { setBusy(true); try { await edit(job.id, name); } finally { setBusy(false); } };
  return <div className="video-catalog-actions">
    {job.state === 'completed' && job.downloadUrl && <details><summary>Play video</summary><video className="catalog-player" controls preload="none" src={job.downloadUrl} /></details>}
    <details className="video-title-editor"><summary>Rename video</summary>
      <form onSubmit={event => { event.preventDefault(); if (title.trim() && !busy) void apply(title.trim()); }}>
        <label htmlFor={titleId}>Video title</label>
        <div className="video-title-fields"><input id={titleId} value={title} maxLength={120} disabled={busy} onChange={event => setTitle(event.target.value)} />
          <button type="submit" disabled={busy || !title.trim() || title.trim() === job.title}>{busy ? 'Saving…' : 'Save title'}</button></div>
      </form>
    </details>
    <details className="video-delete-editor"><summary>Delete video</summary><div className="video-delete-confirmation"><p>This removes the catalog entry and stored video. An active render will be cancelled.</p><button type="button" disabled={busy} onClick={() => void apply()}>Confirm deletion</button></div></details>
  </div>;
}
